import axios from 'axios'
import { errorHandler } from '../exports/error_management'

import { StorageCache } from '../exports/dataStorage'
const storageKey = 'ams-progress-status-key'

const api = async (method, path, params) => axios[method](path, params)

const state = {
    progress_status: null,
    progress_statuses: [],
}

const mutations = {
    set_progress_status(state, payload) {
        state.progress_status = payload
    },
    set_progress_statuses(state, payload) {
        state.progress_statuses = payload
    },
}

const actions = {
    async create(context, payload) {
        try {
            const results = await api('post', `progress-status`, payload)
            const data = results.data.success.data
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_progress_status', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.progress_statuses },
                data,
                null
            )
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchById(context, id) {
        try {
            await context.dispatch('fetchAll')
            context.commit(
                'set_progress_status',
                context.state.progress_statuses.find(x => x.id == id)
            )
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchAll(context) {
        const storageCache = new StorageCache(storageKey)
        try {
            const { is_valid, value } = storageCache.getArray()
            if (!is_valid) {
                const results = await api('get', `progress-status`)
                console.log('results.data', results.data)
                const data = results.data.success.data
                storageCache.set(data)
                value.splice(0)
                value.push(...data)
            }
            context.commit('set_progress_statuses', value)
        } catch (err) {
            errorHandler(err)
        }
    },
    async updateProgressStatusOrder(context, payload) {
        const storageCache = new StorageCache(storageKey)
        try {
            storageCache.reset()
             await api(
                'post',
                `progress-status/update/display/order/`,
                payload
            )
            context.dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },

    async update(context, payload) {
        console.log('update', payload)
        try {
            const results = await api(
                'put',
                `progress-status/${payload.id}`,
                payload
            )
            const data = results.data.success.data
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_progress_status', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.progress_statuses },
                data,
                payload.id
            )
        } catch (err) {
            errorHandler(err)
        }
    },
    async delete(context, id) {
        try {
            await api('delete', `progress-status/${id}`)
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_progress_status', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.progress_statuses },
                null,
                id
            )
        } catch (err) {
            errorHandler(err)
        }
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
